<template>
  <div class="spawn-changelog animated fadeIn">
    <b-card no-body class="spawn-changelog-toolbar">
      <div class="spawn-changelog-header">
        <div>
          <div class="spawn-changelog-title">
            <i class="fa fa-history text-info"></i>
            <strong>Spawn Changelog</strong>
          </div>
          <small class="text-muted">{{ changelog.length }} uploaded changes</small>
        </div>
        <div class="spawn-changelog-actions">
          <b-button
            size="sm"
            :variant="publicMode ? 'info' : 'outline-secondary'"
            @click="publicMode = !publicMode"
          >
            <i class="fa mr-1" :class="publicMode ? 'fa-globe' : 'fa-lock'"></i>
            {{ publicMode ? 'Public' : 'Internal' }}
          </b-button>
          <b-button size="sm" variant="outline-info" @click="refresh">
            <i class="fa fa-refresh"></i>
          </b-button>
        </div>
      </div>
    </b-card>

    <div v-if="!changelog.length" class="spawn-changelog-empty">
      <i class="fa fa-history"></i>
      <div>No uploaded spawn changes yet.</div>
    </div>

    <section
      v-for="group in groupedChangelog"
      v-else
      :key="'changelog-date-' + group.date"
      class="spawn-changelog-day"
    >
      <h5>{{ group.date }}</h5>
      <article v-for="entry in group.entries" :key="'changelog-entry-' + entry.id" class="spawn-changelog-map">
        <div class="spawn-changelog-map-title">{{ entry.mapName }}</div>
        <pre>{{ entryText(entry) }}</pre>
      </article>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SpawnChangelog',
  data () {
    return {
      publicMode: false
    }
  },
  computed: {
    ...mapGetters({
      changelog: 'spawnWorkflowChangelog'
    }),
    groupedChangelog () {
      const groups = []
      const byDate = Object.create(null)
      ;(this.changelog || []).forEach(entry => {
        const date = this.formatDate(entry.uploadedAt)
        if (!byDate[date]) {
          byDate[date] = { date, entries: [] }
          groups.push(byDate[date])
        }
        byDate[date].entries.push(entry)
      })
      return groups
    }
  },
  created () {
    this.refresh()
  },
  methods: {
    refresh () {
      this.emit('getSpawnEditorWorkflow', {})
    },
    entryText (entry) {
      return this.publicMode ? (entry.publicDetails || entry.details || '') : (entry.details || '')
    },
    formatDate (value) {
      const date = value ? new Date(value) : null
      if (!date || Number.isNaN(date.getTime())) return 'Unknown date'
      return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.spawn-changelog {
  color: #e6edf3;
}

.spawn-changelog-toolbar,
.spawn-changelog-map {
  background: #1f2933;
  border: 1px solid #344150;
  border-radius: 6px;
}

.spawn-changelog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
}

.spawn-changelog-title,
.spawn-changelog-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.spawn-changelog-day {
  margin-top: 18px;
}

.spawn-changelog-day h5 {
  margin-bottom: 10px;
  color: #c9d6e2;
}

.spawn-changelog-map {
  padding: 14px;
  margin-bottom: 12px;
}

.spawn-changelog-map-title {
  font-weight: 700;
  margin-bottom: 8px;
}

.spawn-changelog-map pre {
  margin: 0;
  color: #d9e2ec;
  white-space: pre-wrap;
  font-family: inherit;
  font-size: 0.9rem;
  line-height: 1.45;
}

.spawn-changelog-empty {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #91a4b7;
}

.spawn-changelog-empty i {
  font-size: 34px;
}
</style>
